
import Fab from '@material-ui/core/Fab';
import SearchIcon from '@material-ui/icons/SearchOutlined';
import React, { Fragment } from 'react';
import Dropdown from '../../../core/controls/components/dropdown';
import Label from '../../../core/controls/components/label';
import RadioButtonsGroup from '../../../core/controls/components/radiogroup';
import Textfield from '../../../core/controls/components/textbox';


const extraProps = {
    transformProps: {
        label: 'Name',
        value: 'Id'
    },
}

const domainProps = {
    transformProps: {
        label: 'Name',
        value: 'Value'
    },
}
const outdoorProps={
    transformProps:{
        label:'SystemField31',
        value:'SystemField31'
    }
}



export default function LAOACSApplicationProperties({ handleFieldChange, loadFieldsData, state }) {

    return <Fragment>
         {state.subModuleKey === "VIOLATIONS" &&           
                <div className='col-6  m-3'>
                        {<RadioButtonsGroup extraProps={domainProps} items={state.violationtype || []} handleFieldValue={handleFieldChange} value={state.VIOLATION_TYPE || 'NP'} label='Violation Type' name='VIOLATION_TYPE'/>}
                </div>
        }     
         <div className='col-12 row m-1'>
            {/* {(state.subModuleKey === "INQUIRY" || (state.subModuleKey === "APPLICATIONS" && state.VIOLATION_TYPE === 'PE')) && <Dropdown  className="col-sm-6 col-md-4 col-lg-3 col-xs-12" name='WHAT_WOULD_YOU_LIKE_TO_DO_'
                value={state.WHAT_WOULD_YOU_LIKE_TO_DO_} handleFieldValue={handleFieldChange}
                label={'What would you like to do'}
                items={state.whatwldTypes} extraProps={domainProps} />
            }  */}
             {state.subModuleKey === "VIOLATIONS" && state.VIOLATION_TYPE == 'PE' && state.GetAllOutdoorIssuedPermitsItems &&             
                        <Dropdown className="col-sm-6 col-md-4 col-lg-3 col-xs-12"  extraProps={outdoorProps} items={state.GetAllOutdoorIssuedPermitsItems || []} handleFieldValue={handleFieldChange} value={state.OUTDOOR_PERMIT_NO} label='Outdoor Permit No #' name='OUTDOOR_PERMIT_NO' required={true} />            
                    }
            {state.subModuleKey != "VIOLATIONS" &&<Dropdown className="col-3"  extraProps={extraProps} items={state.sitepermittype || []} handleFieldValue={handleFieldChange} value={state.SITE_PERMIT_TYPE_ID} label='Permit Type' name='SITE_PERMIT_TYPE_ID'/>}
             <Dropdown className="col-sm-6 col-md-4 col-lg-3 col-xs-12" extraProps={extraProps} items={state.applicationsite || []} handleFieldValue={handleFieldChange} value={state.SITE_ID} label={'Parish'} name={'SITE_ID'} />
            <Dropdown className="col-sm-6 col-md-4 col-lg-3 col-xs-12" extraProps={extraProps} items={state.applicationdistricts || []} handleFieldValue={handleFieldChange} value={state.DISTRICT_ID} label={'District'} name={'DISTRICT_ID'} />
        </div>
       
    </Fragment>
}



//value={((state.applicationregion || []).find(each => String(each.Id) === String(state.REGION_ID)) || {}).Name}